(ns manage.content-variant-ocp.db.core
  (:require [clojure.set :refer [rename-keys]]
            [common.util :as util]
            [mate.core :as mc]
            [re-frame.core :as rf]))

(def entity-name "Content-variant")

(def ui-messages
  {:create {:success "Successfully created sheet import configuration"
            :failure "Failed to create sheet import configuration"}
   :edit {:success "Successfully saved sheet import configuration"
          :failure "Failed to save sheet import configuration"}})

(defn ->internal-classification
  [field-name-classes]
  (mc/index-by :name :class field-name-classes))

(defn ->external-classification
  [field-name->field-class]
  (->> field-name->field-class
       (into [] (keep (fn [[field-name field-class]]
                        (when (some? field-class)
                          {:name field-name
                           :class field-class}))))))

(defn ->internal-field-formats
  [settings]
  (reduce (fn [acc cur]
            (assoc acc (:name cur)
                   (cond
                     (-> cur :format :multi)
                     (rename-keys (:format cur) {:delimiter :separator})

                     (:postcode-type cur)
                     {:postcode true :postcode-type (:postcode-type cur)})))
          {} settings))

(defn ->external-field-formats
  [settings]
  (keep (fn [[k v]]
          (cond
            (:multi v)
            {:name k
             :format {:multi (:multi v)
                      :delimiter (:separator v)}}

            (:postcode v)
            {:name k
             :postcode-type (:postcode-type v)}))
        settings))

(defn ->internal-content-mappings
  [field-names field-name-classes content-mappings]
  (let [field-name->field-class (mc/index-by :name :class field-name-classes)
        field-name->field-content-mapping (mc/index-by :name content-mappings)]
    (->> field-names
         (keep field-name->field-content-mapping)
         (map (fn [{:keys [name placeholder]}]
                [name (or placeholder
                          {:name name
                           :type (if (= (field-name->field-class name) "click-through-key")
                                   "click"
                                   "text")})]))
         (into {}))))

(defn ->external-content-mappings
  [content-mappings]
  (->> content-mappings
       (keep (fn [[column {:keys [type name]}]]
               (when (and (some? type)
                          (some? name))
                 {:name column
                  :placeholder {:type type
                                :name name}})))))

(defn field-classes-flow [feed-id]
  {:id :form.content-variant/field-classes-flow
   :first-dispatch [:resource.feed-importers/get-fields feed-id]
   :rules [{:when :seen?
            :events :resource.feed-importers/get-fields-success
            :halt? false
            :dispatch [:form.content-variant/get-fields-success]}
           {:when :seen?
            :events :resource.feed-importers/get-content-feed-success
            :halt? true
            :dispatch [:form.content-variant/get-content-feed-success]}]})

(rf/reg-event-db :form.content-variant/set-dirty
  (fn [db] (assoc-in db [:form.content-variant :dirty?] true)))

(rf/reg-sub :form.content-variant/dirty?
  (fn [db] (get-in db [:form.content-variant :dirty?])))

(rf/reg-event-fx :form.content-variant/open
  [(rf/inject-cofx :sub :resource.feed-importers/one)]
  (fn [{:resource.feed-importers/keys [one]} _]
    (let [feed (:value one)]
      {:fx [[:dispatch [:resource.template/upgrade-hints]] ; Loads the placeholders from the assigned templates
            (when feed [:async-flow (field-classes-flow (:id feed))])
            [:dispatch [:ocp/open {:id :content-variant/crud
                                   :on-close [:form.content-variant/close]}]]
            [:dispatch [:form.content-variant.sheet-import/open]]]})))

(rf/reg-event-fx :form.content-variant/close
  [(rf/inject-cofx :sub :resource.adset/current-feed-id)
   (rf/inject-cofx :sub :form.content-variant/dirty?)]
  (fn [{:resource.adset/keys [current-feed-id]
        :form.content-variant/keys [dirty?]} _]
    {:fx [(when (and current-feed-id dirty?) [:dispatch [:resource.feed-importers/trigger current-feed-id]])
          (when (and current-feed-id dirty?) [:dispatch [:page.content-variant/init-content-function]])
          [:dispatch [:form.content-variant.sheet-import/destroy]]
          [:dispatch [:form.content-variant.column-classification/destroy]]
          [:dispatch [:form.content-variant.content-mapping/destroy]]
          [:dispatch [:form.feed-lookup/destroy]]]}))

(rf/reg-event-fx :form.content-variant/get-fields-success
  (fn [{:keys [db]}]
    (let [feed-id (get-in db [:form.content-variant.sheet-import :value :id])
          fields (get-in db [:resource.feed-importers/fields :value])
          mappings (mapv #(hash-map :from % :to (util/sanitize-fieldname %)) fields)]
      {:db (assoc-in db [:form.content-variant.sheet-import :value :mappings] mappings)
       :fx [[:dispatch [:resource.feed-importers/get-content-feed feed-id]]]})))

(rf/reg-event-fx :form.content-variant/get-content-feed-success
  [(rf/inject-cofx :sub :resource.feed-importers/sanitised-fields)]
  (fn [{:keys [db] :resource.feed-importers/keys [sanitised-fields]}]
    (let [{:keys [field-content-mappings
                  field-classes
                  field-formats]} (get-in db [:resource.feed-importers/content-feed :value])
          field-classes (filterv #((set sanitised-fields) (:name %)) field-classes)]
      {:db (-> db
               (assoc-in [:form.content-variant.content-mapping :value :content-mappings]
                         (->internal-content-mappings sanitised-fields field-classes field-content-mappings))
               (assoc-in [:form.content-variant.column-classification :value :raw-classification]
                         (->internal-classification field-classes))
               (assoc-in [:form.feed-lookup :value :settings]
                         (->internal-field-formats field-formats)))})))

(rf/reg-sub :form.content-variant/mode
  (fn [db]
    (get-in db [:form.content-variant.sheet-import :mode])))

(rf/reg-sub :form.content-variant/url
  (fn [db]
    (get-in db [:form.content-variant.sheet-import :value :url])))

(rf/reg-sub :form.content-variant/feed-id
  (fn [db]
    (get-in db [:form.content-variant.sheet-import :value :id])))
